module.exports = __webpack_public_path__ + "static/how-it-works-2-9dc220fd7d56c0dfa69de8342d63f0ff.png";